<div class="overviewBox" [ngClass]="[shipDetailsbasicinfo?.statusInfo?.futureChange === true && 
  shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === false ? 'overViewStatusMsg' : '',
 ( getLngData?.status === 'upcomingChange' && getLngData?.hasPreviousChange )
  || (getScrubberData?.status === 'upcomingChange' && getScrubberData?.hasPreviousChange) 
  || overViewLngInterface.isLoader 
  || overViewStatusInterface.isLoader
  || overViewScrubberInterface.isLoader ? 'addedLngUsageClass' : '']">
  <p class="subHeading sub-heading-s1"><b>Basic information</b></p>
  <ul class="basic-info">
    <li class="basic-row">
      <div class="fleet-ship-col-width">
        <p class="fleet-body-b3 body-b">Ship / Code</p>
        <p class="fleet-section-title section-title fw-700">{{shipDetailsbasicinfo?.vslName}} /
          {{shipDetailsbasicinfo?.vslCode}}</p>
      </div>
      <div class="fleet-ship-col-width">
        <p class="fleet-body-b3 body-b">Pool</p>
        <p class="fleet-section-title section-title fw-700">Pool {{shipDetailsbasicinfo?.subPool}}</p>
      </div>
    </li>
    <li class="basic-row">
      <div class="fleet-ship-col-width">
        <p class="fleet-body-b3 body-b">Ship owner</p>
        <p class="fleet-section-title section-title fw-700">{{shipDetailsbasicinfo.vslOwner}}</p>
      </div>
      <div class="fleet-ship-col-width">
        <p class="fleet-body-b3 body-b">Class</p>
        <p class="fleet-section-title section-title fw-700">{{shipDetailsbasicinfo.vslClass}}</p>
      </div>
    </li>
    <li class="basic-row">
      <div class="fleet-ship-col-width d-ruby">
        <div class="status-style newStatusStyle pr-16">
          <p class="fleet-body-b3 body-b">Current status</p>
          <div class="Skelton-section" *ngIf="overViewStatusInterface?.isLoader">
            <div class="sektion-filter"><span class="Skelton-pp"></span></div>
          </div>
          <ng-container *ngIf="!overViewStatusInterface?.isLoader">        
            <p class="fleet-section-title section-title fw-700" 
              *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === false 
              && shipDetailsbasicinfo?.statusInfo?.futureChange === false 
              ">
              {{shipDetailsbasicinfo?.statusInfo?.currentStatus}}
            </p>
            <p class="fleet-section-title section-title fw-700" 
              *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true 
              && shipDetailsbasicinfo?.statusInfo?.futureChange === false 
              && shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Active'">
              {{shipDetailsbasicinfo?.statusInfo?.currentStatus}}
            </p>   
            <snl-tooltip position="bottom" [config]="toolTipConfig"
              *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && 
              shipDetailsbasicinfo?.statusInfo?.futureChange === false && shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Inactive'">
              <span class="fleet-section-title section-title fw-700 tooltip-border-bottom">
                {{shipDetailsbasicinfo?.statusInfo?.currentStatus}}              
              </span>
              <div tooltipContent class="tooltip-padding">
                <div class="body-b overviewToolTipFontSize">          
                  <span>
                    You can modify the details <br />until
                    <span class="section-title">{{shipDetailsbasicinfo?.statusInfo?.nextCalculationDate | date: 'dd MMM yyyy' }}
                      </span><br /> without affecting distribution.
                  </span>      
                </div>
              </div>
            </snl-tooltip>
            <span class="statusInfoMsgWrap editOverViewStatus_Info body-b" *ngIf="shipDetailsbasicinfo?.statusInfo?.futureChange === true && shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === false">
              <p class="fleet-section-title section-title fw-700"> 
                {{shipDetailsbasicinfo?.statusInfo?.currentStatus}}
              </p>
              <div class="statusInfoMsgTxtWrap">
                <figure>
                  <img src="assets/img/infoGray.svg" alt="information">
                </figure>
                <span class="statusInfoMsgTxt" > 
                  Status will change to 
                  <b class="editStatusInfoVal">
                    {{editStatusDetails?.upcomingChange?.status}}</b> from <b class="editStausDateInfo">{{editStatusDetails?.upcomingChange?.effectiveDate | date: 'dd MMM yyyy'}}</b>
                </span>
              </div>      
            </span>  
          </ng-container>     
        </div>
        <app-edit-overview-status 
          [shipDetailsbasicinfo]="shipDetailsbasicinfo"
          (getupdateEditStatusDetails)="updateEditStatus($event)"
          [editStatusDetails]="editStatusDetails"
          (getEditStatusLoaderEvent)="editStatusLoader()"
          (errorEditStatusLoaderEvent)="errorEditStatusLoader()" >
        </app-edit-overview-status>
      </div>
      <div class="fleet-ship-col-width">
        <p class="fleet-body-b3  body-b">Status effective from</p>
        <p class="fleet-section-title section-title fw-700">{{shipDetailsbasicinfo.statusEffectiveFrom | date:'dd MMM yyyy'}}</p>
      </div>
    </li>
    <div class="line pt-24"></div>
    <li class="basic-row">
      <div class="fleet-ship-col-width d-ruby">
        <div>
          <p class="fleet-body-b3  body-b">Is scrubber in use?</p>
          <div class="Skelton-section" *ngIf="overViewScrubberInterface?.isLoader">
            <div class="sektion-filter"><span class="Skelton-pp"></span></div>
          </div>
          <ng-container *ngIf="!overViewScrubberInterface?.isLoader">
            <ng-container *ngIf="getScrubberData?.hasPreviousChange === false">
              <p class="fleet-section-title section-title fw-700">{{getScrubberData?.currentScrubberUsage === true ? 'Yes' : 'No'}}</p>
            </ng-container>
            <ng-container *ngIf="getScrubberData?.status === 'noChange' && getScrubberData?.hasPreviousChange">
              <p class="fleet-section-title section-title fw-700">{{getScrubberData?.currentScrubberUsage === false ? 'No' : 'Yes'}}</p>
            </ng-container>
            <ng-container *ngIf="getScrubberData?.status === 'upcomingChange' && getScrubberData?.hasPreviousChange">
              <p class="fleet-section-title section-title fw-700">{{getScrubberData?.currentScrubberUsage === false ? 'No' : 'Yes'}}</p>
              <span class="updateLngData statusInfoMsgWrap body-b">
                <figure>
                  <img src="assets/img/infoGray.svg" alt="information">
                </figure>
                <span class="statusInfoMsgTxt"> 
                  <span *ngIf="!getScrubberData?.currentScrubberUsage"> Scrubber will be in use from</span>
                  <span *ngIf="getScrubberData?.currentScrubberUsage"> Scrubber will no longer be in use from</span>
                  <b class="updateDateLng ">{{getScrubberData?.upcomingEffectiveDate | date: 'dd MMM yyyy'}}</b> 
                </span>
              </span>
            </ng-container>
            <ng-container *ngIf="getScrubberData?.status === 'pendingCalculation' && getScrubberData?.hasPreviousChange">
              <snl-tooltip position="bottom" [config]="toolTipConfig">
                <span class="fleet-section-title section-title fw-700 tooltip-border-bottom">
                  {{getScrubberData?.currentScrubberUsage === false ? 'No' : 'Yes'}}
                </span>
                <div tooltipContent class="tooltip-padding ">
                  <div class="body-b overviewToolTipFontSize">
                    <span>
                      You can modify the details <br />until
                      <span class="section-title">{{getScrubberData?.nextCalculationDate | date: 'dd MMM yyyy' }}</span><br /> without affecting distribution.
                    </span>
                  </div>
                </div>
              </snl-tooltip>
            </ng-container>
          </ng-container>
        </div>

        <div class="editbuttonBox">
          <app-edit-scrubber-usage
            [shipDetailsbasicinfo]="shipDetailsbasicinfo"
            [getScrubberData]="getScrubberData"
            (getupdateScrubberUsage)="updateScrubberData($event)"
            (getScrubberUsageLoaderEvent)="scrubberUsageLoader()"
            (errorScrubberUsageLoaderEvent)="errorScrubberUsageLoader()" >
          </app-edit-scrubber-usage>
        </div>
      </div>
      <div class="fleet-ship-col-width d-ruby">
        <div>
          <p class="fleet-body-b3 body-b">Is LNG in use?</p>
          <div class="Skelton-section" *ngIf="overViewLngInterface?.isLoader">
            <div class="sektion-filter"><span class="Skelton-pp"></span></div>
          </div>
          <ng-container *ngIf="!overViewLngInterface?.isLoader">
            <ng-container *ngIf="getLngData?.hasPreviousChange === false">
              <p class="fleet-section-title section-title fw-700">{{getLngData?.currentLng === 0 ? 'No' : 'Yes'}}</p>
            </ng-container>
            <ng-container *ngIf="getLngData?.status === 'noChange' && getLngData?.hasPreviousChange">
              <p class="fleet-section-title section-title fw-700">{{getLngData?.currentLng === 0 ? 'No' : 'Yes'}}</p>
            </ng-container>
            <ng-container *ngIf="getLngData?.status === 'upcomingChange' && getLngData?.hasPreviousChange">
              <p class="fleet-section-title section-title fw-700">{{getLngData?.currentLng === 0 ? 'No' : 'Yes'}}</p>
              <span class="updateLngData statusInfoMsgWrap body-b">
                <figure>
                  <img src="assets/img/infoGray.svg" alt="information">
                </figure>
                <span class="statusInfoMsgTxt"> 
                  <span *ngIf="getLngData?.upComingLng === 1">LNG will be in use from</span>
                  <span *ngIf="getLngData?.upComingLng === 0">LNG will no longer be in use from</span>
                  <b class="updateDateLng ">{{getLngData?.upcomingEffectiveDate | date: 'dd MMM yyyy'}}</b> 
                </span>
              </span>
            </ng-container>
            <ng-container *ngIf="getLngData?.status === 'pendingCalculation' && getLngData?.hasPreviousChange">
              <snl-tooltip position="bottom" [config]="toolTipConfig">
                <span class="fleet-section-title section-title fw-700 tooltip-border-bottom">
                  {{getLngData?.currentLng === 0 ? 'No' : 'Yes'}}
                </span>
                <div tooltipContent class="tooltip-padding">
                  <div class="body-b overviewToolTipFontSize">
                    <span>
                      You can modify the details <br />until
                      <span class="section-title">{{getLngData?.nextCalculationDate | date: 'dd MMM yyyy' }}</span><br /> without affecting distribution.
                    </span>
                  </div>
                </div>
              </snl-tooltip>
            </ng-container>
           </ng-container>

        </div>
        <div class="editbuttonBox">
          <app-edit-lng 
            [shipDetailsbasicinfo]="shipDetailsbasicinfo"
            [getLngData]="getLngData"
            (getupdateLngUsage)="updateLngData($event)"
            (getLngStatusLoaderEvent)="lngStatusLoader()"
            (errorLngStatusLoaderEvent)="errorLngStatusLoader()" >
          </app-edit-lng>
        </div> 
      </div>
    </li>
  </ul>
</div>
